import styled from 'styled-components';
import { HIGHLIGHT_SECONDARY, ADMIN_HIGHLIGHT_SECONDARY } from 'style/constants';

export const TextContainer = styled.span``;

export const HighlightedPart = styled.span<{ admin: boolean }>`
  background-color: ${({ admin }) => (admin ? ADMIN_HIGHLIGHT_SECONDARY : HIGHLIGHT_SECONDARY)};
`;
